import Vue from 'vue'

export default {
  initialize: function () {
    // handle global http request progress overlay here
    Vue.http.interceptors.push(function (request) {
      this.$root.httpRequestInProgressCount += 1
        // return response callback
      return function (response) {
        this.$root.httpRequestInProgressCount -= 1
      }
    })
  }
}
